import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function Error() {
  const gotoTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <title>404 Response Page Error - Clubhosty</title>
        <link rel="canonical" href="https://www.clubhosty.com/*" />
      </Helmet>
      <section id="error-404">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center img">
              <img
                src="/assets/img/error.png"
                width="350px"
                alt="404"
                className="img-error"
              />
            </div>
            <div className="col-md-12">
              <div className="error-text">
                <br />
                <div>
                  <center>
                    <h2>
                      Look like you've found the
                      <br />
                      doorway to the great nothing.
                    </h2>
                    <p>You tried to access a page that isn't on out server.</p>
                    <br />
                    <Link to="/" className="btn_primary" onClick={gotoTop}>
                      HOME
                    </Link>
                    <Link
                      to="/contact"
                      className="btn_primary"
                      onClick={gotoTop}
                    >
                      CONTACT US
                    </Link>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Error;
